import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { getAppConfiguration, getTeamLabel, Team, trackAnalytics } from '@puffin/app-frame-api';
import { alpha, Avatar, Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useApplicationSettings } from '../../state/configuration/application-settings';
import { useAuthenticatedUser } from '../../services/auth/AuthenticatedUserContext';

export const UserSummary = ({ collapsed = false }: { collapsed?: boolean }) => {
  const user = useAuthenticatedUser();
  const { openSettings } = useApplicationSettings();
  if (!user) {
    return null;
  }
  const { team } = getAppConfiguration();
  const openApplicationSettings = () => {
    trackAnalytics('APPLICATION_CONFIGURATION_OPENED', {});
    openSettings();
  };

  if (collapsed) {
    return (
      <Stack sx={{ alignItems: 'center', my: 1.5 }}>
        <Tooltip title={`${user.name} — Open settings`} placement="right">
          <IconButton aria-label="Open settings" onClick={openApplicationSettings}>
            <SettingsRoundedIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={(theme) => ({
        alignItems: 'center',
        mx: 1.5,
        my: 1.5,
        px: 1.5,
        py: 1.25,
        border: 1,
        borderColor: 'divider',
        borderRadius: 2.5,
        bgcolor: alpha(theme.palette.background.paper, 0.42),
      })}
    >
      <Avatar
        alt={user.name}
        sx={(theme) => ({
          width: 36,
          height: 36,
          fontSize: 14,
          background: `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
        })}
      >
        {user.itdId?.toUpperCase()}
      </Avatar>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="body2" noWrap sx={{ fontWeight: 600 }}>
          {user.name}
        </Typography>
        {team !== Team.OTHER && (
          <Typography variant="caption" color="text.secondary" noWrap>
            Team {getTeamLabel(team)}
          </Typography>
        )}
      </Box>
      <Tooltip title="Open settings">
        <IconButton aria-label="Open settings" size="small" onClick={openApplicationSettings}>
          <SettingsRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
